import {
  IVisualizationState,
  IPeerGroupTabsProps,
  IFilter,
  round,
} from "../../lib/http";
import * as React from "react";
import { Panel } from "react-bootstrap";
import * as ReactHighcharts from "react-highcharts";

export class PaidTrusteesOrOfficers extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["Other_T_V17_Vis17Column"]
    );

    const selectedLightColor = "#8EA9DB";
    const selectedDarkColor = "#305496";
    const nonselectedLightColor = "#D9E1F2";
    const nonselectedDarkColor = "#B4C6E7";

    const paidData = filterOutAllFoundations.map((dataPoint) => {
      const yValue =
        parseFloat((dataPoint["Other_N_V17_PaidTrustee"] * 100.0).toFixed(1)) *
        1.0;
      return dataPoint.filterId === filters.assetLevel
        ? {
          y: yValue,
          color: selectedLightColor,
          dataLabels: { color: "#fff" },
        }
        : { y: yValue, color: nonselectedLightColor };
    });
    const unpaidData = filterOutAllFoundations.map((dataPoint) => {
      const yValue =
        parseFloat(
          (dataPoint["Other_N_V17_UnpaidTrustee"] * 100.0).toFixed(1)
        ) * 1.0;
      return dataPoint.filterId === filters.assetLevel
        ? { y: yValue, color: selectedDarkColor, dataLabels: { color: "#fff" } }
        : { y: yValue, color: nonselectedDarkColor };
    });

    const title = currentSet ? currentSet["Other_T_V17_Vis17Title"] : "";
    const unpaidTitle = currentSet
      ? currentSet["Other_T_V17_UnpaidBubble"]
      : "";
    const paidTitle = currentSet ? currentSet["Other_T_V17_PaidBubble"] : "";
    const series = [
      {
        color: "#D9E1F2",
        name: unpaidTitle,
        data: unpaidData,
        borderWidth: 1,
        borderColor: "#a1a1a1",
      },
      {
        color: "#B4C6E7",
        name: paidTitle,
        data: paidData,
        borderWidth: 1,
        borderColor: "#a1a1a1",
      },
    ];

    this.setState({ title, series, categories });
  }

  getChartConfig(series) {
    const { categories } = this.state;
    return {
      chart: {
        type: "column",
        height: 300,
      },
      title: {
        text: "No Compensation Paid",
        floating: true,
        x: -250,
        y: 65,
        style: {
          fontSize: "12px",
          color: "#666666",
        },
      },
      subtitle: {
        text: "Compensation Paid",
        floating: true,
        x: 300,
        y: 220,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
            color: "#a1a1a1",
            format: "{y}%",
            style: {
              textOutline: false,
            },
          },
        },
      },
      series,
    };
  }

  render() {
    const { title, loading, series } = this.state;
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}
          {loading && <i className="fa fa-cog fa-spin"></i>}
        </div>
        <div className="panel-body">
          <ReactHighcharts config={this.getChartConfig(series)} ref="chart" />
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Other/PaidTrusteesOrOfficers/index.tsx